import curdGenerator from "./curdGenerator";

export const diagnosis = [
  {
    module: "Diagnosis",
    children: [
      {
        module: "Masters",
        children: [
          curdGenerator("Departmental Sub Speciality"),
          curdGenerator("Investigation Category"),
          curdGenerator("Pathology Test"),
          curdGenerator("Radiology Test"),
          curdGenerator("Panel"),
          curdGenerator("Sub Speciality Seperate Test Rates")
        ]
      },
      {
        module: "Transactions",
        children: [
          curdGenerator("Lab Registration"),
          curdGenerator("Pathology Test Value"),
          curdGenerator("Radiology Test Value"),
          curdGenerator("Payment Receive"),
          curdGenerator("Pathology Status"),
          curdGenerator("Lab Refund"),
          curdGenerator("Lab Registration Multiple"),
          curdGenerator("Form F"),
          curdGenerator("Expense")
        ]
      },
      {
        module: "Reports",
        children: [
          {
            module: "Lab Registration Report",
            permission: "labregistrationreport",
            children: []
          },
          {
            module: "Area Wise Lab Registration Report",
            permission: "areawiselabregistrationreport",
            children: []
          },
          {
            module: "Consultant Test Wise Lab Registration Report",
            permission: "consultanttestwiselabregistrationreport",
            children: []
          },
          {
            module: "Patient Test Report",
            permission: "patienttestreport",
            children: []
          },
          {
            module: "Lab Dues Report",
            permission: "labduesreport",
            children: []
          },
          {
            module: "Category Test Wise Register",
            permission: "categorytestwiseregister",
            children: []
          },
          {
            module: "Category Wise Census Report",
            permission: "categorywisecensusreport",
            children: []
          },
          {
            module: "Category Wise Lab Summary",
            permission: "categorywiselabsummary",
            children: []
          },
          {
            module: "Sub Speciality Patient Statistical Report",
            permission: "subspecialitypatientstatisticalreport",
            children: []
          },
          {
            module: "Department Summary",
            permission: "departmentsummary",
            children: []
          },
          {
            module: "Month Wise Summary",
            permission: "monthwisesummary",
            children: []
          },
          {
            module: "Category Wise Test Wise Report",
            permission: "categorywisetestwisereport",
            children: []
          },
          {
            module: "Worksheet Print",
            permission: "worksheetprint",
            children: []
          },
          {
            module: "Form F Report",
            permission: "formfreport",
            children: []
          },
          {
            module: "Lab Refund Report",
            permission: "labrefundreport",
            children: []
          },
          {
            module: "Lab Discount Report",
            permission: "labdiscountreport",
            children: []
          },
          {
            module: "Test Negative Report",
            permission: "testnegativereport",
            children: []
          },
          {
            module: "Pending Test Report",
            permission: "pendingtestreport",
            children: []
          },
          {
            module: "Lab Ledger Report",
            permission: "labledgerreport",
            children: []
          }
        ]
      }
    ]
  }
];
